<template>
    <div class="washing-volume-chart2">
        <Chart :cdata="cdata" />
    </div>
</template>

<script>
import Chart from './chart.vue'
import * as api from '@/api/index'
export default {
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            cdata: {
                xAxis: [],
                seriesData: []
            }
        };
    },
    components: {
        Chart,
    },
    watch: {
        data: {
            handler(newData) {
                console.log(newData, '娲楁钉閲忔暟鎹?--------------')
                
                if (newData && newData.length > 0) {
                    this.cdata.xAxis = []
                    this.cdata.seriesData = newData.map(item => {
                        // 澶勭悊鏈堜唤鏄剧ず鏍煎紡
                        let monthDisplay = item.month
                        if (item.month && item.month.length === 2) {
                            monthDisplay = `2024-${item.month}`
                        }
                        
                        this.cdata.xAxis.push(monthDisplay)
                        return {
                            value: item.num || 0,
                            month: monthDisplay,
                            remark: item.remark || ''
                        }
                    })
                }
            },
            deep: true,
            immediate: true,
        }
    },
    
    mounted() {
        
    },
    methods: {
        
    }
};
</script>

<style lang="scss" scoped>
.washing-volume-chart2 {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
